exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article[data-v-86de3d28]:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 38px;\n  left: -20px;\n  width: 10px;\n  height: 10px;\n  border-radius: 5px;\n  background-color: #682327;\n}\n.article .subject[data-v-86de3d28] {\n  position: relative;\n  overflow: visible;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 38px;\n  height: 38px;\n}", ""]);

// exports
